import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'srcReact/components/icons/Icon'
import IconButtonPure from './IconButtonPure'

function IconButton({ iconName, iconSize, iconCSS, className, onClick, ...rest }) {
  return (
    <IconButtonPure
      renderIcon={() => <Icon name={iconName} size={iconSize} styleModifier={iconCSS} />}
      className={className}
      onClick={onClick}
      {...rest}
    />
  )
}

IconButton.propTypes = {
  iconName: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
  iconCSS: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
}

IconButton.defaultProps = {
  iconSize: 'large24'
}

export default IconButton
